<template>
  <button
    @click="update"
    :class="primaryColor.class"
    class="container focus:outline-none"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <g clip-path="url(#clip0_23405_32890)">
        <path
          d="M1.85891 8.62707C1.88894 8.62699 1.91897 8.62692 1.9499 8.62684C1.98318 8.62687 2.01645 8.62691 2.04972 8.62695C2.08511 8.6269 2.12049 8.62685 2.15587 8.62679C2.25314 8.62664 2.35041 8.62665 2.44768 8.62667C2.55256 8.62668 2.65745 8.62655 2.76234 8.62644C2.96783 8.62624 3.17333 8.62618 3.37882 8.62617C3.54582 8.62616 3.71281 8.62611 3.87981 8.62603C4.3531 8.62583 4.82638 8.62572 5.29967 8.62574C5.32519 8.62574 5.35071 8.62574 5.377 8.62574C5.41533 8.62574 5.41533 8.62574 5.45443 8.62574C5.86869 8.62575 6.28295 8.62553 6.69721 8.6252C7.1224 8.62486 7.54759 8.6247 7.97278 8.62472C8.21156 8.62473 8.45034 8.62466 8.68912 8.62441C8.89239 8.6242 9.09565 8.62414 9.29892 8.6243C9.40265 8.62438 9.50639 8.62438 9.61012 8.62418C9.70506 8.62399 9.8 8.62403 9.89493 8.62423C9.9293 8.62427 9.96367 8.62422 9.99803 8.62409C10.0447 8.62393 10.0914 8.62408 10.1381 8.62425C10.164 8.62424 10.19 8.62424 10.2167 8.62423C10.3263 8.6331 10.4054 8.657 10.4906 8.72704C10.5567 8.80589 10.6031 8.8865 10.6509 8.97725C10.6715 9.01534 10.6921 9.05339 10.7128 9.09142C10.7294 9.12177 10.7294 9.12177 10.7462 9.15274C10.8077 9.26384 10.8722 9.37315 10.9365 9.48262C11.058 9.68985 11.178 9.89791 11.2969 10.1066C11.4168 10.3173 11.5378 10.5272 11.6601 10.7365C11.6736 10.7597 11.6871 10.7829 11.701 10.8069C11.7577 10.9043 11.8146 11.0014 11.8746 11.0969C11.9586 11.2324 12.0272 11.3471 12.0126 11.5114C11.9937 11.5838 11.961 11.6271 11.9062 11.677C11.8321 11.714 11.7523 11.7037 11.6709 11.7035C11.6511 11.7036 11.6313 11.7037 11.6109 11.7037C11.5438 11.7039 11.4767 11.7039 11.4096 11.7038C11.3613 11.7039 11.313 11.704 11.2647 11.7041C11.1315 11.7043 10.9982 11.7044 10.8649 11.7045C10.7214 11.7046 10.5779 11.7048 10.4343 11.705C10.1039 11.7055 9.77341 11.7057 9.44294 11.7059C9.27972 11.706 9.11649 11.7061 8.95327 11.7062C8.39477 11.7067 7.83627 11.707 7.27777 11.7072C7.2427 11.7072 7.20762 11.7072 7.17255 11.7072C7.15516 11.7072 7.13777 11.7072 7.11984 11.7072C7.03172 11.7073 6.94359 11.7073 6.85546 11.7073C6.82923 11.7073 6.82923 11.7073 6.80247 11.7073C6.23522 11.7075 5.66797 11.7081 5.10072 11.7088C4.5013 11.7096 3.90188 11.7101 3.30245 11.7102C3.23669 11.7102 3.17092 11.7102 3.10516 11.7102C3.08896 11.7102 3.07277 11.7102 3.05608 11.7102C2.79516 11.7103 2.53424 11.7106 2.27331 11.7111C2.01119 11.7116 1.74906 11.7117 1.48694 11.7115C1.34485 11.7114 1.20277 11.7114 1.06069 11.7119C0.93073 11.7123 0.800782 11.7123 0.670827 11.7119C0.623699 11.7119 0.57657 11.712 0.529443 11.7122C0.465589 11.7126 0.401762 11.7124 0.337909 11.712C0.319429 11.7122 0.30095 11.7125 0.28191 11.7127C0.194647 11.7116 0.145281 11.7034 0.0711437 11.6557C-0.00893799 11.5734 -0.0124393 11.5065 -0.0110186 11.3948C0.0111746 11.2548 0.0925021 11.1398 0.165507 11.0207C0.182692 10.9918 0.199825 10.9629 0.216908 10.9339C0.252063 10.8745 0.287463 10.8152 0.323069 10.756C0.401319 10.6256 0.476589 10.4935 0.552225 10.3615C0.581289 10.3112 0.610372 10.2608 0.639475 10.2105C0.7125 10.0841 0.785462 9.95768 0.858389 9.83124C0.887487 9.7808 0.916593 9.73036 0.945707 9.67993C1.01413 9.56139 1.08249 9.44282 1.15063 9.32412C1.18268 9.2683 1.21476 9.2125 1.24685 9.1567C1.26937 9.11751 1.29184 9.07828 1.31431 9.03905C1.50021 8.71586 1.50021 8.71586 1.59373 8.65352C1.68267 8.62959 1.7671 8.62713 1.85891 8.62707Z"
          :fill="primaryColor.color"
        />
        <path
          d="M3.88504 5.08744C3.90376 5.08737 3.92248 5.0873 3.94177 5.08723C4.0047 5.08702 4.06764 5.08699 4.13058 5.08695C4.17562 5.08684 4.22066 5.08673 4.2657 5.0866C4.38821 5.08629 4.51073 5.08614 4.63325 5.08604C4.70976 5.08597 4.78628 5.08587 4.86279 5.08577C5.10211 5.08545 5.34143 5.08522 5.58075 5.08513C5.85716 5.08502 6.13357 5.08461 6.40997 5.08393C6.62353 5.08343 6.83709 5.08319 7.05064 5.08316C7.17824 5.08313 7.30583 5.083 7.43342 5.08258C7.55344 5.08219 7.67346 5.08214 7.79348 5.08235C7.83753 5.08236 7.88158 5.08226 7.92562 5.08203C7.98577 5.08173 8.0459 5.08187 8.10605 5.08212C8.12347 5.08193 8.14088 5.08174 8.15883 5.08154C8.2689 5.08259 8.34447 5.10197 8.43751 5.16104C8.47758 5.21631 8.50946 5.267 8.54151 5.32657C8.56189 5.36277 8.58228 5.39896 8.60267 5.43515C8.61368 5.45501 8.6247 5.47486 8.63604 5.49532C8.68833 5.58892 8.74219 5.68159 8.79595 5.77435C8.84124 5.85252 8.88636 5.93079 8.93144 6.00909C9.0061 6.13875 9.08084 6.26837 9.15562 6.39796C9.18457 6.44814 9.21353 6.49833 9.24248 6.54853C9.31117 6.66763 9.37989 6.7867 9.44874 6.90571C9.48128 6.96196 9.51381 7.01823 9.54633 7.07449C9.56931 7.11424 9.59232 7.15397 9.61534 7.19369C9.62923 7.21774 9.64313 7.24179 9.65745 7.26657C9.6697 7.28773 9.68194 7.30889 9.69456 7.33069C9.76004 7.44709 9.79109 7.53232 9.77345 7.66885C9.73418 7.75916 9.6999 7.79694 9.60939 7.83292C9.55156 7.83879 9.55156 7.83879 9.48537 7.83881C9.4601 7.83894 9.43482 7.83906 9.40878 7.83918C9.38103 7.83908 9.35328 7.83898 9.32469 7.83887C9.2952 7.83894 9.26571 7.83901 9.23532 7.83909C9.15341 7.83929 9.0715 7.83919 8.98958 7.83904C8.90126 7.83894 8.81295 7.8391 8.72463 7.83923C8.55159 7.83944 8.37855 7.83939 8.20551 7.83926C8.06491 7.83915 7.92431 7.83914 7.7837 7.83919C7.76371 7.8392 7.74371 7.8392 7.72311 7.83921C7.6825 7.83923 7.64188 7.83924 7.60126 7.83926C7.22021 7.83939 6.83915 7.83924 6.4581 7.83898C6.13098 7.83877 5.80386 7.83881 5.47674 7.83903C5.09707 7.83928 4.7174 7.83938 4.33772 7.83923C4.29726 7.83922 4.25679 7.8392 4.21632 7.83919C4.19641 7.83918 4.17649 7.83917 4.15598 7.83917C4.01551 7.83913 3.87504 7.83919 3.73457 7.8393C3.56343 7.83944 3.39229 7.8394 3.22116 7.83915C3.13381 7.83903 3.04646 7.83898 2.9591 7.83913C2.86451 7.8393 2.76992 7.8391 2.67533 7.83887C2.6337 7.83903 2.6337 7.83903 2.59124 7.83918C2.56596 7.83906 2.54069 7.83894 2.51465 7.83881C2.4928 7.83881 2.47096 7.8388 2.44846 7.83879C2.35971 7.82977 2.31237 7.80484 2.25587 7.73624C2.21108 7.63323 2.20582 7.53608 2.24557 7.43126C2.27344 7.37632 2.30356 7.32342 2.33497 7.27042C2.35227 7.24012 2.35227 7.24012 2.36993 7.20921C2.40766 7.14342 2.44598 7.078 2.48439 7.0126C2.51007 6.96842 2.53573 6.92423 2.56138 6.88003C2.61568 6.78665 2.67023 6.69342 2.72489 6.60025C2.80974 6.4553 2.89315 6.30956 2.97628 6.16362C3.02331 6.08109 3.07047 5.99862 3.11762 5.91616C3.15652 5.84811 3.19538 5.78005 3.23414 5.71193C3.27847 5.63415 3.32305 5.55651 3.36769 5.47891C3.3809 5.4556 3.39412 5.43229 3.40774 5.40828C3.53608 5.18621 3.61749 5.08713 3.88504 5.08744Z"
          :fill="primaryColor.color"
        />
        <path
          d="M5.99857 1.23398C6.01764 1.23346 6.0367 1.23295 6.05634 1.23242C6.16972 1.25987 6.23221 1.32549 6.29446 1.41984C6.33459 1.48897 6.37262 1.55894 6.41019 1.62949C6.43926 1.68273 6.46838 1.73596 6.49753 1.78915C6.51962 1.82962 6.51962 1.82962 6.54214 1.87091C6.60839 1.99088 6.67759 2.10904 6.74711 2.22714C6.86669 2.43094 6.98465 2.6356 7.1016 2.84091C7.23604 3.07693 7.37185 3.31211 7.50933 3.54637C7.54545 3.608 7.58139 3.66973 7.61722 3.73154C7.62869 3.75119 7.64016 3.77084 7.65197 3.79109C7.66262 3.80968 7.67327 3.82828 7.68424 3.84744C7.69832 3.87188 7.69832 3.87188 7.71269 3.8968C7.74804 3.97114 7.74803 4.02631 7.73441 4.10654C7.68479 4.20047 7.64605 4.25579 7.54691 4.29404C7.48745 4.30007 7.48745 4.30007 7.41913 4.3003C7.3802 4.3006 7.3802 4.3006 7.34048 4.30091C7.3121 4.30089 7.28373 4.30087 7.2545 4.30085C7.22454 4.301 7.19458 4.30116 7.16371 4.30132C7.08158 4.30174 6.99945 4.30185 6.91732 4.30188C6.86598 4.30191 6.81464 4.30201 6.7633 4.30213C6.58413 4.30257 6.40495 4.30276 6.22577 4.30272C6.05887 4.30269 5.89198 4.30319 5.72508 4.30393C5.58169 4.30454 5.4383 4.30479 5.2949 4.30476C5.2093 4.30475 5.12371 4.30489 5.03811 4.30538C4.94262 4.30592 4.84713 4.30571 4.75163 4.30542C4.72336 4.30569 4.69508 4.30595 4.66595 4.30622C4.51813 4.30511 4.424 4.30167 4.31254 4.20029C4.25143 4.11973 4.25809 4.04084 4.26566 3.94247C4.29096 3.87626 4.32602 3.81717 4.36234 3.75644C4.37276 3.73837 4.38318 3.72031 4.39391 3.70169C4.42895 3.64112 4.46449 3.58087 4.50004 3.5206C4.52549 3.47689 4.55091 3.43315 4.5763 3.3894C4.63115 3.29503 4.68619 3.20078 4.74137 3.1066C4.82901 2.95686 4.91585 2.80667 5.00248 2.65634C5.01698 2.63119 5.03147 2.60604 5.04641 2.58013C5.10618 2.47642 5.16593 2.37268 5.22566 2.26895C5.30042 2.13913 5.37524 2.00936 5.45026 1.8797C5.50102 1.79197 5.55139 1.70404 5.60132 1.61584C5.62192 1.57986 5.64252 1.54388 5.66312 1.5079C5.67197 1.49203 5.68082 1.47615 5.68993 1.45979C5.76501 1.32966 5.84039 1.23373 5.99857 1.23398Z"
          :fill="primaryColor.color"
        />
      </g>
      <defs>
        <clipPath id="clip0_23405_32890">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.473633)"
          />
        </clipPath>
      </defs>
    </svg>

    <i
      v-if="loading"
      class="pi pi-spinner text-xs animate-spin transition duration-100"
    />

    <template v-else>
      <p class="text">Tier {{ currentTier }}</p>

      <div v-show="showUpgrade" class="divide"></div>

      <p v-if="kycState === 'pending' && currentTier === 0" class="action">
        Verification pending
      </p>
      <p
        v-else-if="kycState === 'not_verified' && currentTier === 0"
        class="action"
      >
        Complete KYC
      </p>
      <p v-else class="action">Verified</p>
    </template>
  </button>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useDataStore } from "@/stores/data.js";
import { useKycInfo } from "@/composable/useKycInfo";
const router = useRouter();
const store = useDataStore();

const loading = ref(false);
const { overallStatus: kycState } = useKycInfo();
const companyData = computed(() => store.getCompanyDetails);

const currentTier = computed(() => {
  if (companyData.value && companyData.value.tier) {
    return Number(companyData.value.tier);
  }
  return 0;
});

const primaryColor = computed(() => {
  const obj = {
    0: { class: "bckgrd1", color: "#9747FF" },
    1: { class: "bckgrd1", color: "#9747FF" },
    2: { class: "bckgrd2", color: "#2f80ed" },
    3: { class: "bckgrd3", color: "#219653" },
    4: { class: "bckgrd4", color: "#11453b" },
    5: { class: "bckgrd4", color: "#11453b" },
  };
  return obj[currentTier.value];
});

const showUpgrade = computed(() => {
  if (
    (companyData.value &&
      companyData.value.registrationType === "PERSONAL" &&
      currentTier !== 4) ||
    (companyData.value &&
      companyData.value.registrationType === "COMPANY" &&
      currentTier.value !== 5)
  ) {
    return true;
  }
  return false;
});

const update = () => {
  if (
    !loading.value &&
    kycState.value === "not_verified" &&
    currentTier.value === 0
  ) {
    router.push({
      name: "Register",
      query: { page: 3, step: 1 },
    });
  }
};

async function queryKyc() {
  try {
    loading.value = true;
    const res = await store.query({
      endpoint: "GetKycInformation",
      payload: {},
      service: "SETTINGS",
      storeKey: "listKyc",
    });
  } catch (err) {
    console.log(err);
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  queryKyc();
});
</script>

<style scoped>
.container {
  width: fit-content;
  border-radius: 12px;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
}
.bckgrd1 {
  border: 1px solid rgba(151, 71, 255, 0.1);
  background: rgba(151, 71, 255, 0.1);
  color: #9747ff;
}
.bckgrd2 {
  border: 1px solid rgba(47, 128, 237, 0.1);
  background: rgba(47, 128, 237, 0.1);
  color: #2f80ed;
}

.bckgrd3 {
  border: 1px solid rgba(33, 150, 83, 0.1);
  background: rgba(33, 150, 83, 0.1);
  color: #219653;
}

.bckgrd4 {
  border: 1px solid rgba(17, 69, 59, 0.1);
  background: rgba(17, 69, 59, 0.1);
  color: #11453b;
}

.text {
  /* color: #9747ff; */

  /* Note/Normal/Medium */
  font-family: Aeonik;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
}

.divide {
  width: 1px;
  height: 12px;
  background: rgba(151, 71, 255, 0.1);
}

.action {
  /* color: #9747ff; */

  /* Note/Normal/Medium */
  font-family: Aeonik;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px; /* 120% */
}
</style>
